




















































import Vue from "vue";
import {EntityService} from "@/services/entity.service";
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
const entityService = new EntityService()

export default Vue.extend({
	name: 'AudioEdit',
	mixins: [validationMixin],
	validations: {
		form: {
			name: {required, maxLength: maxLength(150)}
		}
	},
	props: ['value', 'editEntity'],
	data: () => ({
		entity: 'audios',
		isLoading: false,
		form: {
			id: 0,
			name: '',
			description: '',
			archived: false
		}
	}),
	async created() {
		this.form = {
			id: this.editEntity.id,
			name: this.editEntity.name,
			description: this.editEntity.description,
			archived: this.editEntity.archived,
		}
	},
	methods: {
		toggleModal (value: boolean) {
			this.$emit('input', value)
		},
		async save() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isLoading = true
				await entityService.updateEntity(this.entity, this.form)
				this.isLoading = false
				this.$emit('input', false)
			}
		},
		getError: function (element: string) {
			const obj = this.$v['form'][element] || {$error: ''}
			if (obj.$error) return 'Campo requerido'
			return;
		}
	},
})
